import { render, staticRenderFns } from "./CaseSidebar.vue?vue&type=template&id=36b9420d&scoped=true&"
import script from "./CaseSidebar.vue?vue&type=script&lang=js&"
export * from "./CaseSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CaseSidebar.vue?vue&type=style&index=0&id=36b9420d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9420d",
  null
  
)

export default component.exports